export default {
  BLOT_NAME: 'hashtag',
  CLASS_NAME: 'ql-hashtag',
  START_CHAR: '#',
}
